import React, { Fragment } from "react";

import {
  Container,
} from "reactstrap";

import Breadcrumbs from "../../Components/Common/Breadcrumb";

import PaymentHistory from "../../Components/Recruiter/PaymentHistory/PaymentHistory";

const PaymentHistoryPage = () => {

  return (
    <Fragment>

      <Breadcrumbs
        title="Payment History"
        mainTitle="Payment History"
      />

      <Container fluid={true}>

        <PaymentHistory />

      </Container>

    </Fragment>
  );
};

export default PaymentHistoryPage;